export default __webpack_public_path__ + "static/media/Cabin4.0419a53c.jpg";